/**
 * Sauvegardes du serveur, vues depuis l'administration (décision 96).
 *
 * La plateforme ne fait que LISTER et REMETTRE telles quelles les archives
 * que `infra/scripts/backup.sh` écrit chaque nuit. Elle ne les déchiffre
 * jamais : la clé age n'est pas sur la plateforme.
 */
import { z } from 'zod';
/**
 * Le nom d'une archive, tel que `backup.sh` le compose :
 * `afs-<env>-<AAAAMMJJ>T<HHMMSS>Z[-<étiquette>].tar.age`.
 *
 * Motif strict, ancré aux deux bouts : ni `/`, ni `\`, ni espace. C'est ce
 * qui interdit `../` dans une demande de téléchargement, avant même de
 * toucher au disque.
 */
export const MOTIF_ARCHIVE_SAUVEGARDE = /^afs-([a-z]+)-(\d{8}T\d{6}Z)(?:-([A-Za-z0-9][A-Za-z0-9._-]{0,63}))?\.tar\.age$/;
export const schemaNomArchive = z.object({
    nom: z.string().max(120).regex(MOTIF_ARCHIVE_SAUVEGARDE, 'Nom d’archive invalide.'),
});
/**
 * L'empreinte sha256 écrite par `backup.sh` à côté de l'archive, recalculée
 * par la plateforme :
 *   CONFORME    recalculée, identique
 *   DIFFERENTE  recalculée, différente : l'archive est altérée ou tronquée
 *   A_VERIFIER  pas encore recalculée (le calcul tourne en arrière-plan)
 *   ABSENTE     aucun fichier d'empreinte à côté de l'archive
 */
export const ETATS_EMPREINTE = ['CONFORME', 'DIFFERENTE', 'A_VERIFIER', 'ABSENTE'];
export const schemaArchiveSauvegarde = z.object({
    nom: z.string(),
    /** Horodatage UTC tiré du nom : c'est l'heure de la sauvegarde, pas de la copie. */
    faiteLe: z.string(),
    /** `pre-deploy-v1.2.0`, `pre-restore`… ; nulle pour la sauvegarde quotidienne. */
    etiquette: z.string().nullable(),
    octets: z.number().int().nonnegative(),
    empreinte: z.enum(ETATS_EMPREINTE),
    /** Faux si le fichier existe mais que la plateforme n'a pas le droit de le lire. */
    lisible: z.boolean(),
});
export const schemaListeSauvegardes = z.object({
    environnement: z.string(),
    /** Faux si le dossier des sauvegardes n'est pas monté ou pas lisible. */
    disponible: z.boolean(),
    archives: z.array(schemaArchiveSauvegarde),
});
/** Le jeton à usage unique rendu après la nouvelle saisie du code. */
export const schemaAutorisationTelechargement = z.object({
    jeton: z.string(),
    expireLe: z.string(),
});
export const schemaDemandeTelechargement = z.object({
    jeton: z.string().regex(/^[a-f0-9]{64}$/, 'Autorisation invalide.'),
});
//# sourceMappingURL=sauvegardes.js.map